/* MBI product recall helper — 2026-09-08.7 + Polish-edition copy note
   (country routing, English/Polish localization, refund evidence) */
(function () {
  'use strict';

  var FORM_SELECTOR =
    '.template-page-product-recall [data-form-root] shopify-forms-embed,' +
    '.template-page-product-recall-form [data-form-root] shopify-forms-embed';
  var COUNTRY_STORAGE_KEY = 'mbi-recall-country-of-purchase';
  var FORM_COUNTRY_CODES = [
    'AR', 'BH', 'BR', 'CL', 'CO', 'GT', 'IL', 'IR', 'LB', 'AE', 'ZW',
    'BM', 'BN', 'IN', 'ID', 'MY', 'MU', 'SG',
    'CA', 'DE', 'IE', 'PL', 'NZ', 'ZA', 'GB', 'US'
  ];
  var COUNTRIES = [
    ['AF', 'Afghanistan'], ['AX', 'Åland Islands'], ['AL', 'Albania'],
    ['DZ', 'Algeria'], ['AS', 'American Samoa'], ['AD', 'Andorra'],
    ['AO', 'Angola'], ['AI', 'Anguilla'], ['AQ', 'Antarctica'],
    ['AG', 'Antigua and Barbuda'], ['AR', 'Argentina'], ['AM', 'Armenia'],
    ['AW', 'Aruba'], ['AU', 'Australia'], ['AT', 'Austria'],
    ['AZ', 'Azerbaijan'], ['BS', 'Bahamas'], ['BH', 'Bahrain'],
    ['BD', 'Bangladesh'], ['BB', 'Barbados'], ['BY', 'Belarus'],
    ['BE', 'Belgium'], ['BZ', 'Belize'], ['BJ', 'Benin'],
    ['BM', 'Bermuda'], ['BT', 'Bhutan'], ['BO', 'Bolivia'],
    ['BQ', 'Bonaire, Sint Eustatius and Saba'], ['BA', 'Bosnia and Herzegovina'],
    ['BW', 'Botswana'], ['BV', 'Bouvet Island'], ['BR', 'Brazil'],
    ['IO', 'British Indian Ocean Territory'], ['BN', 'Brunei Darussalam'],
    ['BG', 'Bulgaria'], ['BF', 'Burkina Faso'], ['BI', 'Burundi'],
    ['CV', 'Cabo Verde'], ['KH', 'Cambodia'], ['CM', 'Cameroon'],
    ['CA', 'Canada'], ['KY', 'Cayman Islands'], ['CF', 'Central African Republic'],
    ['TD', 'Chad'], ['CL', 'Chile'], ['CN', 'China'],
    ['CX', 'Christmas Island'], ['CC', 'Cocos (Keeling) Islands'],
    ['CO', 'Colombia'], ['KM', 'Comoros'], ['CG', 'Congo'],
    ['CD', 'Congo, Democratic Republic of the'], ['CK', 'Cook Islands'],
    ['CR', 'Costa Rica'], ['CI', "Côte d’Ivoire"], ['HR', 'Croatia'],
    ['CU', 'Cuba'], ['CW', 'Curaçao'], ['CY', 'Cyprus'],
    ['CZ', 'Czechia'], ['DK', 'Denmark'], ['DJ', 'Djibouti'],
    ['DM', 'Dominica'], ['DO', 'Dominican Republic'], ['EC', 'Ecuador'],
    ['EG', 'Egypt'], ['SV', 'El Salvador'], ['GQ', 'Equatorial Guinea'],
    ['ER', 'Eritrea'], ['EE', 'Estonia'], ['SZ', 'Eswatini'],
    ['ET', 'Ethiopia'], ['FK', 'Falkland Islands'], ['FO', 'Faroe Islands'],
    ['FJ', 'Fiji'], ['FI', 'Finland'], ['FR', 'France'],
    ['GF', 'French Guiana'], ['PF', 'French Polynesia'],
    ['TF', 'French Southern Territories'], ['GA', 'Gabon'], ['GM', 'Gambia'],
    ['GE', 'Georgia'], ['DE', 'Germany'], ['GH', 'Ghana'],
    ['GI', 'Gibraltar'], ['GR', 'Greece'], ['GL', 'Greenland'],
    ['GD', 'Grenada'], ['GP', 'Guadeloupe'], ['GU', 'Guam'],
    ['GT', 'Guatemala'], ['GG', 'Guernsey'], ['GN', 'Guinea'],
    ['GW', 'Guinea-Bissau'], ['GY', 'Guyana'], ['HT', 'Haiti'],
    ['HM', 'Heard Island and McDonald Islands'], ['VA', 'Holy See'],
    ['HN', 'Honduras'], ['HK', 'Hong Kong'], ['HU', 'Hungary'],
    ['IS', 'Iceland'], ['IN', 'India'], ['ID', 'Indonesia'],
    ['IR', 'Iran'], ['IQ', 'Iraq'], ['IE', 'Ireland'],
    ['IM', 'Isle of Man'], ['IL', 'Israel'], ['IT', 'Italy'],
    ['JM', 'Jamaica'], ['JP', 'Japan'], ['JE', 'Jersey'],
    ['JO', 'Jordan'], ['KZ', 'Kazakhstan'], ['KE', 'Kenya'],
    ['KI', 'Kiribati'], ['KP', 'Korea, North'], ['KR', 'Korea, South'],
    ['KW', 'Kuwait'], ['KG', 'Kyrgyzstan'], ['LA', 'Laos'],
    ['LV', 'Latvia'], ['LB', 'Lebanon'], ['LS', 'Lesotho'],
    ['LR', 'Liberia'], ['LY', 'Libya'], ['LI', 'Liechtenstein'],
    ['LT', 'Lithuania'], ['LU', 'Luxembourg'], ['MO', 'Macao'],
    ['MG', 'Madagascar'], ['MW', 'Malawi'], ['MY', 'Malaysia'],
    ['MV', 'Maldives'], ['ML', 'Mali'], ['MT', 'Malta'],
    ['MH', 'Marshall Islands'], ['MQ', 'Martinique'], ['MR', 'Mauritania'],
    ['MU', 'Mauritius'], ['YT', 'Mayotte'], ['MX', 'Mexico'],
    ['FM', 'Micronesia'], ['MD', 'Moldova'], ['MC', 'Monaco'],
    ['MN', 'Mongolia'], ['ME', 'Montenegro'], ['MS', 'Montserrat'],
    ['MA', 'Morocco'], ['MZ', 'Mozambique'], ['MM', 'Myanmar'],
    ['NA', 'Namibia'], ['NR', 'Nauru'], ['NP', 'Nepal'],
    ['NL', 'Netherlands'], ['NC', 'New Caledonia'], ['NZ', 'New Zealand'],
    ['NI', 'Nicaragua'], ['NE', 'Niger'], ['NG', 'Nigeria'],
    ['NU', 'Niue'], ['NF', 'Norfolk Island'], ['MK', 'North Macedonia'],
    ['MP', 'Northern Mariana Islands'], ['NO', 'Norway'], ['OM', 'Oman'],
    ['PK', 'Pakistan'], ['PW', 'Palau'], ['PS', 'Palestine'],
    ['PA', 'Panama'], ['PG', 'Papua New Guinea'], ['PY', 'Paraguay'],
    ['PE', 'Peru'], ['PH', 'Philippines'], ['PN', 'Pitcairn'],
    ['PL', 'Poland'], ['PT', 'Portugal'], ['PR', 'Puerto Rico'],
    ['QA', 'Qatar'], ['RE', 'Réunion'], ['RO', 'Romania'],
    ['RU', 'Russia'], ['RW', 'Rwanda'], ['BL', 'Saint Barthélemy'],
    ['SH', 'Saint Helena, Ascension and Tristan da Cunha'],
    ['KN', 'Saint Kitts and Nevis'], ['LC', 'Saint Lucia'],
    ['MF', 'Saint Martin (French part)'], ['PM', 'Saint Pierre and Miquelon'],
    ['VC', 'Saint Vincent and the Grenadines'], ['WS', 'Samoa'],
    ['SM', 'San Marino'], ['ST', 'São Tomé and Príncipe'],
    ['SA', 'Saudi Arabia'], ['SN', 'Senegal'], ['RS', 'Serbia'],
    ['SC', 'Seychelles'], ['SL', 'Sierra Leone'], ['SG', 'Singapore'],
    ['SX', 'Sint Maarten (Dutch part)'], ['SK', 'Slovakia'],
    ['SI', 'Slovenia'], ['SB', 'Solomon Islands'], ['SO', 'Somalia'],
    ['ZA', 'South Africa'], ['GS', 'South Georgia and the South Sandwich Islands'],
    ['SS', 'South Sudan'], ['ES', 'Spain'], ['LK', 'Sri Lanka'],
    ['SD', 'Sudan'], ['SR', 'Suriname'], ['SJ', 'Svalbard and Jan Mayen'],
    ['SE', 'Sweden'], ['CH', 'Switzerland'], ['SY', 'Syria'],
    ['TW', 'Taiwan'], ['TJ', 'Tajikistan'], ['TZ', 'Tanzania'],
    ['TH', 'Thailand'], ['TL', 'Timor-Leste'], ['TG', 'Togo'],
    ['TK', 'Tokelau'], ['TO', 'Tonga'], ['TT', 'Trinidad and Tobago'],
    ['TN', 'Tunisia'], ['TR', 'Türkiye'], ['TM', 'Turkmenistan'],
    ['TC', 'Turks and Caicos Islands'], ['TV', 'Tuvalu'], ['UG', 'Uganda'],
    ['UA', 'Ukraine'], ['AE', 'United Arab Emirates'],
    ['GB', 'United Kingdom'], ['US', 'United States'],
    ['UM', 'United States Minor Outlying Islands'], ['UY', 'Uruguay'],
    ['UZ', 'Uzbekistan'], ['VU', 'Vanuatu'], ['VE', 'Venezuela'],
    ['VN', 'Vietnam'], ['VG', 'Virgin Islands, British'],
    ['VI', 'Virgin Islands, U.S.'], ['WF', 'Wallis and Futuna'],
    ['EH', 'Western Sahara'], ['YE', 'Yemen'], ['ZM', 'Zambia'],
    ['ZW', 'Zimbabwe'], ['ZZ', 'Other / country not listed']
  ];

  /* US/CA variant, requested by legal 2 September 2026.
     Claimants in these countries see a reduced ISBN list; every other approved
     country keeps the full list configured in the Shopify Form. Changing the
     variant is a data change here — no new page, template or form is needed. */
  var REDUCED_ISBN_COUNTRIES = ['US', 'CA'];
  var REDUCED_ISBN_VALUES = ['9781836422594', '9781836427131'];

  var COPY = {
    en: {
      languageLabel: 'Language selection',
      countryError: 'Select the country where the book was purchased.',
      eligibility: 'Recall information for books purchased in',
      chooseCountry: 'Choose a different country',
      confirmationsHeading: 'Please confirm the following',
      recallPhoto: 'Upload one clear JPEG, HEIC or WebP photo showing the registered book page and all of its cut-up wings. Submit a separate request for each book.',
      batchCode: 'Enter the 8-digit batch code printed below the barcode on the back cover (for example 05202602). This is not required for the Polish edition (EAN/ISBN-13 9788384253960).',
      batchError: 'Value must 8 digits (for example 05202602).',
      signature: 'By typing your full name, you are providing your signature and confirming that the information and statements in this request are true and correct.',
      referencePlaceholder: 'Generated when submitted',
      referenceLabel: 'Your claim reference is:',
      copyReference: 'Copy reference',
      keepReference: 'Keep this reference for future correspondence.',
      anotherCopy: 'If you have another recalled copy, submit a separate request for that book.',
      anotherLink: 'Register another copy',
      clipboardCopy: 'Claim reference:',
      selectManually: 'Select and copy the reference manually.',
      referenceCopied: 'Reference copied.'
    },
    pl: {
      languageLabel: 'Wybór języka',
      countryError: 'Wybierz kraj, w którym książka została zakupiona.',
      eligibility: 'Informacje dotyczące wycofania książek zakupionych w kraju:',
      chooseCountry: 'Wybierz inny kraj',
      confirmationsHeading: 'Potwierdź poniższe oświadczenia',
      recallPhoto: 'Prześlij jedno wyraźne zdjęcie w formacie JPEG, HEIC lub WebP, przedstawiające stronę zgłaszanej książki i wszystkie pocięte skrzydełka. Dla każdej książki prześlij osobne zgłoszenie.',
      batchCode: 'Wpisz 8-cyfrowy kod partii wydrukowany pod kodem kreskowym na tylnej okładce (na przykład 05202602). Kod partii nie jest wymagany w przypadku polskiego wydania (EAN/ISBN-13 9788384253960).',
      batchError: 'Wartość musi składać się z 8 cyfr (na przykład 05202602).',
      signature: 'Wpisując imię i nazwisko, składasz podpis oraz potwierdzasz, że informacje i oświadczenia zawarte w tym zgłoszeniu są prawdziwe i zgodne ze stanem faktycznym.',
      referencePlaceholder: 'Zostanie wygenerowany po wysłaniu',
      referenceLabel: 'Numer Twojego zgłoszenia:',
      copyReference: 'Kopiuj numer zgłoszenia',
      keepReference: 'Zachowaj ten numer do przyszłej korespondencji.',
      anotherCopy: 'Jeśli masz kolejny wycofywany egzemplarz, prześlij dla niego osobne zgłoszenie.',
      anotherLink: 'Zgłoś kolejny egzemplarz',
      clipboardCopy: 'Numer zgłoszenia:',
      selectManually: 'Zaznacz i skopiuj numer ręcznie.',
      referenceCopied: 'Numer zgłoszenia został skopiowany.'
    }
  };

  var observedRoots = new WeakSet();
  var submissionByHost = new WeakMap();

  function config() {
    return window.mbiRecallConfig || {};
  }

  function baseLocale(value) {
    return String(value || '').toLowerCase().split('-')[0];
  }

  function activeLocale() {
    var localization = config().localization || {};
    var locale = localization.locale ||
      (window.Shopify && window.Shopify.language) ||
      document.documentElement.lang || 'en';
    return baseLocale(locale) === 'pl' ? 'pl' : 'en';
  }

  function text(key) {
    return COPY[activeLocale()][key] || COPY.en[key] || '';
  }

  function routeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) root = '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function recallRoute(name) {
    var routes = config().routes || {};
    var path = routes[name] || {
      landing: 'pages/i-spy-a-fly-product-recall',
      form: 'pages/i-spy-a-fly-recall-registration',
      other: 'pages/i-spy-a-fly-recall-other-countries'
    }[name];
    return routeRoot() + String(path || '').replace(/^\//, '');
  }

  function selectedCountryCode() {
    var query = new URLSearchParams(window.location.search).get('country');
    if (query && /^[A-Z]{2}$/i.test(query)) return query.toUpperCase();
    try {
      return (window.sessionStorage.getItem(COUNTRY_STORAGE_KEY) || '').toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function storeCountry(code) {
    try {
      window.sessionStorage.setItem(COUNTRY_STORAGE_KEY, code);
    } catch (error) {
      /* Routing still works when storage is unavailable. */
    }
  }

  function countryName(code) {
    if (activeLocale() === 'pl') {
      if (code === 'ZZ') return 'Inny / kraj niewymieniony';
      if (code === 'PL') return 'Polska';
      if (window.Intl && window.Intl.DisplayNames) {
        try {
          return new window.Intl.DisplayNames(['pl'], { type: 'region' }).of(code);
        } catch (error) {
          /* Fall through to the curated English name. */
        }
      }
    }
    for (var index = 0; index < COUNTRIES.length; index += 1) {
      if (COUNTRIES[index][0] === code) return COUNTRIES[index][1];
    }
    return '';
  }

  function usesRecallForm(code) {
    return FORM_COUNTRY_CODES.indexOf(code) !== -1;
  }

  function usesReducedIsbnSet(code) {
    return REDUCED_ISBN_COUNTRIES.indexOf(code) !== -1;
  }

  function countryList(value) {
    return String(value || '')
      .split(',')
      .map(function (entry) { return entry.trim().toUpperCase(); })
      .filter(Boolean);
  }

  /* Country-scoped page content.
     Any element in the Shopify page HTML may carry
       data-recall-country-only="US,CA"   → shown only in those countries
       data-recall-country-except="US,CA" → shown everywhere but those countries
     The CSS default-hides the "only" variant so a slow script never flashes
     content at the wrong country. */
  function applyCountryScopes() {
    var code = selectedCountryCode();
    var scoped = document.querySelectorAll(
      '[data-recall-country-only],[data-recall-country-except]'
    );

    scoped.forEach(function (element) {
      var only = countryList(element.getAttribute('data-recall-country-only'));
      var except = countryList(element.getAttribute('data-recall-country-except'));
      var visible = true;

      if (only.length) visible = only.indexOf(code) !== -1;
      if (visible && except.length) visible = except.indexOf(code) === -1;

      element.hidden = !visible;
      if (visible) element.setAttribute('data-recall-country-visible', '');
      else element.removeAttribute('data-recall-country-visible');
    });
  }

  function populateCountrySelector() {
    var select = document.querySelector('[data-recall-country]');
    if (!select || select.getAttribute('data-recall-ready') === 'true') return;

    COUNTRIES.slice().sort(function (a, b) {
      if (a[0] === 'ZZ') return 1;
      if (b[0] === 'ZZ') return -1;
      return countryName(a[0]).localeCompare(countryName(b[0]), activeLocale());
    }).forEach(function (country) {
      var option = document.createElement('option');
      option.value = country[0];
      option.textContent = countryName(country[0]);
      select.appendChild(option);
    });

    var prior = selectedCountryCode();
    if (countryName(prior)) select.value = prior;
    select.setAttribute('data-recall-ready', 'true');
  }

  function enhanceCountryForm() {
    var form = document.querySelector('[data-recall-country-form]');
    if (!form || form.getAttribute('data-recall-ready') === 'true') return;

    form.setAttribute('data-recall-ready', 'true');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var select = form.querySelector('[data-recall-country]');
      var error = form.querySelector('[data-recall-country-error]');
      var code = select ? select.value : '';

      if (!code) {
        if (error) error.textContent = text('countryError');
        if (select) select.focus();
        return;
      }

      if (error) error.textContent = '';
      storeCountry(code);
      var target = usesRecallForm(code) ? recallRoute('form') : recallRoute('other');
      window.location.assign(target + '?country=' + encodeURIComponent(code));
    });
  }

  function enhanceRecallRoutes() {
    document.querySelectorAll('[data-recall-route]').forEach(function (link) {
      link.href = recallRoute(link.getAttribute('data-recall-route'));
    });
  }

  function availableLanguage(code) {
    var languages = (config().localization || {}).languages || [];
    return languages.some(function (language) {
      return baseLocale(language) === code;
    });
  }

  function submitLanguage(code) {
    var forms = Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/localization"]')
    );
    var form = forms.find(function (candidate) {
      return candidate.querySelector('[name="language_code"],[name="locale_code"]');
    });

    if (form) {
      var control = form.querySelector('[name="language_code"],[name="locale_code"]');
      var input = control.matches('input[type="hidden"]') ? control : form.querySelector(
        'input[type="hidden"][name="' + control.name + '"][data-mbi-recall-language-value]'
      );
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = control.name;
        input.setAttribute('data-mbi-recall-language-value', '');
        form.appendChild(input);
      }
      input.value = code;
      form.submit();
      return;
    }

    /* Fallback matching Shopify's documented localization request. */
    form = document.createElement('form');
    form.method = 'post';
    form.action = routeRoot() + 'localization';
    form.acceptCharset = 'UTF-8';
    form.enctype = 'multipart/form-data';
    form.hidden = true;
    [
      ['form_type', 'localization'],
      ['utf8', '\u2713'],
      ['_method', 'put'],
      ['language_code', code],
      ['return_to', window.location.pathname + window.location.search + window.location.hash]
    ].forEach(function (field) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = field[0];
      input.value = field[1];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function enhanceLanguageSwitcher() {
    var page = document.querySelector('[data-recall-page]');
    if (!page || page.querySelector('[data-recall-language-switcher]')) return;
    if ((config().localization || {}).showLanguageSwitcher !== true) return;
    if (!availableLanguage('en') || !availableLanguage('pl')) return;

    var nav = document.createElement('nav');
    nav.className = 'mbi-recall-language-switcher';
    nav.setAttribute('data-recall-language-switcher', '');
    nav.setAttribute('aria-label', text('languageLabel'));

    [['en', 'English'], ['pl', 'Polski']].forEach(function (language, index) {
      if (index) {
        var separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '|';
        nav.appendChild(separator);
      }

      if (activeLocale() === language[0]) {
        var current = document.createElement('span');
        current.className = 'mbi-recall-language-switcher__current';
        current.setAttribute('aria-current', 'page');
        current.setAttribute('lang', language[0]);
        current.textContent = language[1];
        nav.appendChild(current);
        return;
      }

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mbi-recall-language-switcher__button';
      button.setAttribute('lang', language[0]);
      button.textContent = language[1];
      button.addEventListener('click', function () { submitLanguage(language[0]); });
      nav.appendChild(button);
    });

    page.insertBefore(nav, page.firstChild);
  }

  function enhancePageEligibility() {
    var page = document.querySelector('[data-recall-page]');
    if (!page) return;

    var pageType = page.getAttribute('data-recall-page');
    if (pageType !== 'form' && pageType !== 'other') return;

    var code = selectedCountryCode();
    if (!code || !countryName(code)) {
      if (!(window.Shopify && window.Shopify.designMode)) {
        window.location.replace(recallRoute('landing'));
      }
      return;
    }

    if (pageType === 'form' && !usesRecallForm(code)) {
      window.location.replace(recallRoute('other') + '?country=' + encodeURIComponent(code));
      return;
    }

    if (pageType === 'other' && usesRecallForm(code)) {
      window.location.replace(recallRoute('form') + '?country=' + encodeURIComponent(code));
      return;
    }

    storeCountry(code);
    var panel = page.querySelector('[data-recall-eligibility]');
    if (panel) {
      panel.innerHTML = '<p>' + text('eligibility') + ' <strong>' +
        countryName(code) + '</strong>.</p><a class="mbi-product-recall__country-button" href="' +
        recallRoute('landing') + '">' + text('chooseCountry') + '</a>';
    }
  }

  function enhanceImages() {
    var assets = config().assets || {};
    document.querySelectorAll('[data-recall-image]').forEach(function (image) {
      var source = assets[image.getAttribute('data-recall-image')];
      if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
    });
    document.querySelectorAll('[data-recall-image-link]').forEach(function (link) {
      var source = assets[link.getAttribute('data-recall-image-link')];
      if (source && link.getAttribute('href') !== source) link.setAttribute('href', source);
    });
  }

  function labelText(input, root) {
    var labelId = input.getAttribute('aria-labelledby');
    var label = labelId ? root.getElementById(labelId) : null;
    return ((label && label.textContent) || input.getAttribute('aria-label') || '').trim();
  }

  function findInput(root, pattern) {
    var inputs = root.querySelectorAll('input, select, textarea');
    for (var index = 0; index < inputs.length; index += 1) {
      if (pattern.test(labelText(inputs[index], root))) return inputs[index];
    }
    return null;
  }

  function setFormValue(input, value) {
    var prototype = input instanceof window.HTMLSelectElement
      ? window.HTMLSelectElement.prototype
      : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');

    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;

    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function lockSystemField(input, hide) {
    input.readOnly = true;
    input.setAttribute('readonly', '');
    input.setAttribute('aria-readonly', 'true');
    var field = input.parentElement;
    if (field) {
      field.setAttribute('data-mbi-recall-system-field', '');
      if (hide) {
        field.hidden = true;
        field.removeAttribute('data-mbi-recall-system-visible');
      } else {
        field.hidden = false;
        field.setAttribute('data-mbi-recall-system-visible', '');
      }
    }
  }

  function addDescription(input, helperId) {
    var describedBy = (input.getAttribute('aria-describedby') || '')
      .split(/\s+/).filter(Boolean);
    if (describedBy.indexOf(helperId) === -1) {
      describedBy.push(helperId);
      input.setAttribute('aria-describedby', describedBy.join(' '));
    }
  }

  function createHelper(root, id, text) {
    var existing = root.getElementById(id);
    if (existing) return existing;
    var helper = document.createElement('p');
    helper.id = id;
    helper.className = 'mbi-recall-form-helper';
    helper.textContent = text;
    return helper;
  }

  function addShadowStyles(root) {
    if (root.querySelector('style[data-mbi-recall-form-helpers]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-mbi-recall-form-helpers', '');
    style.textContent =
      'form[data-mbi-recall-form]{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;column-gap:24px!important;row-gap:20px!important}' +
      'form[data-mbi-recall-form]>*{grid-column:1/-1;margin:0!important}' +
      'form[data-mbi-recall-form]>[data-mbi-recall-grid-position]{grid-row:var(--mbi-recall-grid-row)!important}' +
      'form[data-mbi-recall-form]>[data-mbi-recall-grid-column="left"]{grid-column:1!important}' +
      'form[data-mbi-recall-form]>[data-mbi-recall-grid-column="right"]{grid-column:2!important}' +
      'form[data-mbi-recall-form]>[data-mbi-recall-grid-column="full"]{grid-column:1/-1!important}' +
      'form[data-mbi-recall-form]>[data-mbi-recall-half-error]{margin-top:-14px!important}' +
      '[data-mbi-recall-system-field][hidden]{display:none!important}' +
      '[data-mbi-recall-system-visible] input{background:#f3f3f3!important;color:#474747!important;cursor:not-allowed}' +
      '[data-mbi-recall-form-heading]{margin:0 0 20px!important;font-size:clamp(36px,4vw,48px)!important;line-height:1.1!important}' +
      '[data-mbi-recall-phone]{display:grid!important;grid-template-columns:88px minmax(0,1fr)!important;gap:12px!important;align-items:stretch!important;min-width:0!important}' +
      '[data-mbi-recall-phone]>.phone-country-selector,[data-mbi-recall-phone]>.phone-country-selector>div{height:100%!important;min-width:0!important}' +
      '[data-mbi-recall-phone] button{display:flex!important;gap:8px!important;align-items:center!important;justify-content:space-between!important;width:100%!important;min-height:56px!important;height:100%!important;padding:0 14px!important;box-sizing:border-box!important}' +
      '[data-mbi-recall-phone] input[type="tel"]{min-height:56px!important;box-sizing:border-box!important}' +
      '.mbi-phone-country-label{display:none!important}' +
      '[data-mbi-recall-phone] [role="listbox"]{min-width:min(360px,calc(100vw - 64px))!important;max-height:min(520px,60vh)!important}' +
      '[data-mbi-recall-phone] [role="option"]{padding:11px 14px!important;white-space:nowrap!important}' +
      '[data-mbi-recall-photo]{box-sizing:border-box!important;width:100%!important;max-width:100%!important;min-width:0!important;overflow:hidden!important;padding:20px;border:1px solid #d5d5d5;border-radius:14px;background:#fafafa}' +
      '[data-mbi-recall-photo]>p{margin:0 0 12px!important;font-weight:700!important;text-align:center!important}' +
      '[data-mbi-recall-photo]>div{display:flex!important;align-items:center!important;justify-content:center!important;box-sizing:border-box!important;width:100%!important;max-width:100%!important;min-width:0!important;min-height:160px!important;border:2px dashed #a7a7a7!important;border-radius:14px!important;background:#fff!important}' +
      '[data-mbi-recall-photo]>div:hover,[data-mbi-recall-photo]>div:focus-within{border-color:#495bc9!important;background:#f7f8ff!important}' +
      '[data-mbi-recall-affirmation]{box-sizing:border-box!important;width:100%!important;max-width:100%!important;padding:12px 16px!important;border:0!important;border-right:1px solid #cfded9!important;border-left:1px solid #cfded9!important;border-radius:0!important;background:#f7f9f8!important}' +
      '[data-mbi-recall-affirmation]:not([data-mbi-recall-affirmation-first]){margin-top:-20px!important}' +
      '[data-mbi-recall-affirmation]:not([data-mbi-recall-affirmation-last]){box-shadow:inset 0 -1px #dfe7e4}' +
      '[data-mbi-recall-affirmation-first]{border-top:1px solid #cfded9!important;border-radius:12px 12px 0 0!important;padding-top:16px!important}' +
      '[data-mbi-recall-affirmation-last]{border-bottom:1px solid #cfded9!important;border-radius:0 0 12px 12px!important;padding-bottom:16px!important}' +
      '[data-mbi-recall-affirmation] legend[data-mbi-visually-hidden]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}' +
      '[data-mbi-recall-affirmation] label{display:grid!important;grid-template-columns:24px minmax(0,1fr)!important;gap:12px!important;align-items:start!important;cursor:pointer}' +
      '[data-mbi-recall-affirmation] input{margin-top:2px!important}' +
      '[data-mbi-recall-affirmation] label span{font-size:14px!important;line-height:1.45!important}' +
      '.mbi-recall-confirmations-heading{margin:6px 0 -8px!important;color:#1d1d1d;font:700 14px/1.4 Figtree,sans-serif!important}' +
      '[data-mbi-recall-isbn]{box-sizing:border-box!important;width:100%!important;max-width:100%!important;padding:18px!important;border:1px solid #cfded9!important;border-radius:12px!important;background:#fff!important}' +
      '[data-mbi-recall-isbn]>legend{padding:0 8px!important;background:#fff!important;font-weight:700!important}' +
      '[data-mbi-recall-isbn]>div{display:grid!important;clear:both!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:10px 16px!important;margin-top:8px!important}' +
      /* US/CA variant: two options left in the group, so give them two columns
         rather than leaving two empty tracks. */
      '[data-mbi-recall-isbn]>div[data-mbi-recall-isbn-count="1"]{grid-template-columns:minmax(0,1fr)!important}' +
      '[data-mbi-recall-isbn]>div[data-mbi-recall-isbn-count="2"]{grid-template-columns:repeat(2,minmax(0,1fr))!important}' +
      '[data-mbi-recall-isbn]>div[data-mbi-recall-isbn-count="3"]{grid-template-columns:repeat(3,minmax(0,1fr))!important}' +
      '[data-mbi-recall-isbn] [data-mbi-recall-isbn-hidden]{display:none!important}' +
      '.mbi-recall-form-helper{margin:7px 0 2px;color:#5f5f5f;font:normal 400 14px/1.45 Figtree,sans-serif;text-align:left}' +
      '.mbi-recall-photo-helper{text-align:center}' +
      'form[data-mbi-recall-form]>.mbi-recall-signature-helper{margin-top:-12px!important}' +
      'form[data-mbi-recall-form]>button[data-testid="btn-form-submit"]{display:flex!important;align-items:center!important;justify-content:center!important;box-sizing:border-box!important;grid-column:1/-1!important;width:100%!important;max-width:none!important;min-height:54px!important;height:auto!important;padding:15px 32px!important;border:2px solid #495bc9!important;border-radius:15px!important;background:#495bc9!important;color:#fff!important;font-weight:700!important;line-height:1.2!important;cursor:pointer!important;transition:background-color .18s ease,color .18s ease!important}' +
      'form[data-mbi-recall-form]>button[data-testid="btn-form-submit"]:hover,form[data-mbi-recall-form]>button[data-testid="btn-form-submit"]:focus-visible{border-color:#495bc9!important;background:#fff!important;color:#495bc9!important}' +
      '.mbi-recall-reference{margin-top:20px;padding:16px 18px;border:1px solid #d9d9d9;border-radius:10px;background:#f3f3f3;color:#1d1d1d;font:normal 400 16px/1.45 Figtree,sans-serif;text-align:left}' +
      '.mbi-recall-reference p{margin:0 0 8px}' +
      '.mbi-recall-reference__code{display:block;margin:0 0 12px;font:700 17px/1.35 ui-monospace,SFMono-Regular,Menlo,monospace;overflow-wrap:anywhere}' +
      '.mbi-recall-reference__copy{display:inline-flex;align-items:center;min-height:40px;margin:0 0 1em;padding:9px 16px;border:2px solid #495bc9;border-radius:10px;background:#495bc9;color:#fff;font:700 14px/1 Figtree,sans-serif;cursor:pointer}' +
      '.mbi-recall-reference__copy:hover,.mbi-recall-reference__copy:focus-visible{border-color:#495bc9;background:#fff;color:#495bc9}' +
      '.mbi-recall-reference__status{margin:0;font-size:14px}' +
      '.mbi-recall-reference__another-copy{margin:18px 0 8px!important}' +
      '.mbi-recall-reference__another{display:inline-flex;align-items:center;min-height:40px;padding:9px 16px;border:2px solid #495bc9;border-radius:10px;background:#fff;color:#495bc9!important;font:700 14px/1 Figtree,sans-serif;text-decoration:none!important}' +
      '.mbi-recall-reference__another:hover,.mbi-recall-reference__another:focus-visible{background:#495bc9;color:#fff!important}' +
      '@media(max-width:899px){[data-mbi-recall-isbn]>div{grid-template-columns:repeat(2,minmax(0,1fr))!important}}' +
      '@media(max-width:599px){form[data-mbi-recall-form]{grid-template-columns:1fr!important;column-gap:0!important}form[data-mbi-recall-form]>[data-mbi-recall-grid-position]{grid-column:1/-1!important;grid-row:auto!important}[data-mbi-recall-phone]{grid-template-columns:76px minmax(0,1fr)!important}[data-mbi-recall-phone] [role="listbox"]{min-width:min(320px,calc(100vw - 48px))!important;max-height:min(420px,55vh)!important}[data-mbi-recall-isbn]>div{grid-template-columns:1fr!important}}';
    root.appendChild(style);
  }

  function directFormChild(element, form) {
    var current = element;
    while (current && current.parentElement !== form) current = current.parentElement;
    return current && current.parentElement === form ? current : null;
  }

  /* Reduce the ISBN radio group for the US/CA variant.
     The Shopify Form is shared by every approved country, so the unwanted
     options are hidden AND disabled: a disabled control is not focusable and
     is never submitted, so a hidden ISBN cannot reach the Forms record.
     Runs after markFormLayout, which tags the fieldset. */
  function restrictIsbnOptions(root) {
    var fieldset = root.querySelector('[data-mbi-recall-isbn]');
    if (!fieldset) return;

    var container = fieldset.querySelector('div');
    var reduce = usesReducedIsbnSet(selectedCountryCode());
    var visibleCount = 0;

    var options = Array.prototype.map.call(
      fieldset.querySelectorAll('input[type="radio"]'),
      function (radio) {
        var wrapper = (container && directFormChild(radio, container)) ||
          radio.closest('label') || radio;
        /* Read the ISBN from the value, the accessible label and finally the
           option's own text, because Shopify Forms markup varies. */
        var digits = [
          radio.value,
          labelText(radio, root),
          wrapper === radio ? '' : wrapper.textContent
        ].join(' ').replace(/[^0-9]/g, '');
        return {
          radio: radio,
          wrapper: wrapper,
          allowed: REDUCED_ISBN_VALUES.some(function (isbn) {
            return digits.indexOf(isbn) !== -1;
          })
        };
      }
    );

    /* Fail open. If no option matched the reduced list the markup has changed
       and hiding everything would leave a required group with no choices,
       blocking every US/CA claim. Leave the full group and report it. */
    var matched = options.filter(function (option) { return option.allowed; }).length;
    if (reduce && !matched) {
      reduce = false;
      if (window.console && window.console.warn) {
        window.console.warn(
          '[MBI recall] Reduced ISBN list not applied: no option matched ' +
          REDUCED_ISBN_VALUES.join(', ') + '. Check the Shopify Form options.'
        );
      }
    }

    options.forEach(function (option) {
      var radio = option.radio;
      var wrapper = option.wrapper;
      var permitted = !reduce || option.allowed;

      if (permitted) {
        radio.disabled = false;
        radio.removeAttribute('disabled');
        wrapper.hidden = false;
        wrapper.removeAttribute('data-mbi-recall-isbn-hidden');
        visibleCount += 1;
        return;
      }

      /* Clear a stale selection before removing the option from the page. */
      if (radio.checked) {
        radio.checked = false;
        radio.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      }
      radio.disabled = true;
      radio.setAttribute('disabled', '');
      wrapper.hidden = true;
      wrapper.setAttribute('data-mbi-recall-isbn-hidden', '');
    });

    if (container) {
      container.setAttribute('data-mbi-recall-isbn-count', String(visibleCount));
    }
  }

  function markFormLayout(root) {
    var form = root.querySelector('form');
    if (!form) return;
    form.setAttribute('data-mbi-recall-form', '');

    var phoneInput = root.getElementById('phone_number');
    var phoneField = phoneInput && directFormChild(phoneInput, form);
    if (phoneField) phoneField.setAttribute('data-mbi-recall-phone', '');

    var photoInput = root.querySelector('input[type="file"]');
    var photoField = photoInput && directFormChild(photoInput, form);
    if (photoField) photoField.setAttribute('data-mbi-recall-photo', '');

    var affirmations = [];
    root.querySelectorAll('fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var legendText = (legend && legend.textContent || '').trim();
      if (/isbn/i.test(legendText)) fieldset.setAttribute('data-mbi-recall-isbn', '');

      var checkbox = fieldset.querySelector('input[type="checkbox"]');
      var checkboxCopy = checkbox && (checkbox.getAttribute('aria-label') || '');
      if (checkbox && checkboxCopy.length > 20) {
        fieldset.setAttribute('data-mbi-recall-affirmation', '');
        if (legend) legend.setAttribute('data-mbi-visually-hidden', '');
        affirmations.push(fieldset);
      }
    });

    if (affirmations.length) {
      affirmations[0].setAttribute('data-mbi-recall-affirmation-first', '');
      affirmations[affirmations.length - 1]
        .setAttribute('data-mbi-recall-affirmation-last', '');
      var heading = root.querySelector('[data-mbi-recall-confirmations-heading]');
      if (!heading) {
        heading = document.createElement('p');
        heading.className = 'mbi-recall-confirmations-heading';
        heading.setAttribute('data-mbi-recall-confirmations-heading', '');
        heading.textContent = text('confirmationsHeading');
      }
      if (heading.nextElementSibling !== affirmations[0]) {
        form.insertBefore(heading, affirmations[0]);
      }
    }

    positionFormGrid(root, form);
  }

  function setGridPosition(element, column, row, isError) {
    element.setAttribute('data-mbi-recall-grid-position', '');
    element.setAttribute('data-mbi-recall-grid-column', column);
    element.style.setProperty('--mbi-recall-grid-row', String(row));
    if (isError) element.setAttribute('data-mbi-recall-half-error', '');
    else element.removeAttribute('data-mbi-recall-half-error');
  }

  function positionFormGrid(root, form) {
    var groups = [];
    [
      [['first_name', 'left'], ['last_name', 'right']],
      [['custom#city', 'left'], ['custom#state_province_or_region', 'right']],
      [['custom#country_of_purchase', 'left'], ['custom#postal_code', 'right']]
    ].forEach(function (pairGroup) {
      var group = { fields: [], errors: [], members: [] };
      pairGroup.forEach(function (pair) {
        var input = root.getElementById(pair[0]);
        var field = input && directFormChild(input, form);
        if (!field) return;
        group.fields.push({ element: field, column: pair[1] });
        group.members.push(field);
        var error = field.nextElementSibling;
        if (error && error.tagName === 'OUTPUT') {
          group.errors.push({ element: error, column: pair[1] });
          group.members.push(error);
        }
      });
      if (group.members.length) groups.push(group);
    });

    var membership = new Map();
    groups.forEach(function (group) {
      group.members.forEach(function (element) { membership.set(element, group); });
    });

    var processed = new Set();
    var row = 1;
    Array.prototype.forEach.call(form.children, function (element) {
      if (element.hidden) {
        element.removeAttribute('data-mbi-recall-grid-position');
        element.removeAttribute('data-mbi-recall-grid-column');
        element.style.removeProperty('--mbi-recall-grid-row');
        return;
      }

      var group = membership.get(element);
      if (group) {
        if (processed.has(group)) return;
        processed.add(group);
        group.fields.forEach(function (item) {
          setGridPosition(item.element, item.column, row, false);
        });
        group.errors.forEach(function (item) {
          setGridPosition(item.element, item.column, row + 1, true);
        });
        row += group.errors.length ? 2 : 1;
        return;
      }

      setGridPosition(element, 'full', row, false);
      row += 1;
    });
  }

  function markFormHeadings(root) {
    root.querySelectorAll('h2').forEach(function (heading) {
      heading.setAttribute('data-mbi-recall-form-heading', '');
    });
  }

  function enhancePhoneControl(root) {
    var phoneInput = root.getElementById('phone_number');
    var form = root.querySelector('form');
    var phoneField = phoneInput && form && directFormChild(phoneInput, form);
    if (!phoneField) return;
    var button = phoneField.querySelector('button');
    if (!button) return;

    var visible = button.querySelector('.mbi-phone-country-label');
    if (visible) visible.remove();
  }

  function enhanceRecallPhoto(root) {
    var inputs = root.querySelectorAll('input[type="file"]');
    Array.prototype.forEach.call(inputs, function (input, index) {
      if (!/recall\s*photo|photo|zdjęcie/i.test(labelText(input, root))) return;
      var helperId = 'mbi-recall-photo-help-' + index;
      var helper = createHelper(root, helperId, text('recallPhoto'));
      helper.classList.add('mbi-recall-photo-helper');
      var form = root.querySelector('form');
      var photoField = form && directFormChild(input, form);
      var uploadBox = input;
      while (uploadBox && uploadBox.parentElement !== photoField) uploadBox = uploadBox.parentElement;
      if (photoField && uploadBox && !helper.isConnected) {
        photoField.insertBefore(helper, uploadBox);
      }
      addDescription(input, helperId);
    });
  }

  function enhanceBatchCode(root) {
    var input = findInput(root, /^(?:8-digit\s*batch\s*code|8-cyfrowy\s*kod\s*partii)$/i);
    if (!input) return;

    var helperId = 'mbi-recall-batch-code-help';
    var helper = createHelper(root, helperId, text('batchCode'));
    helper.classList.add('mbi-recall-batch-code-helper');
    var form = root.querySelector('form');
    var field = form && directFormChild(input, form);
    if (field && field.parentElement && !helper.isConnected) {
      field.parentElement.insertBefore(helper, field.nextSibling);
    }

    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('maxlength', '8');
    input.setAttribute('pattern', '(0[1-9]|1[0-2])\\d{6}');
    input.setAttribute('title', text('batchError'));
    addDescription(input, helperId);

    if (!input.hasAttribute('data-mbi-recall-batch-enhanced')) {
      input.setAttribute('data-mbi-recall-batch-enhanced', '');
      input.addEventListener('input', function () {
        input.setCustomValidity('');
        if (input.value && !/^(0[1-9]|1[0-2])\d{6}$/.test(input.value)) {
          input.setCustomValidity(text('batchError'));
        }
      });
    }
  }

  function enhanceSignature(root) {
    var signature = findInput(root, /^(?:signature|podpis)$/i);
    if (!signature) return;
    var helperId = 'mbi-recall-signature-help';
    var helper = createHelper(root, helperId, text('signature'));
    helper.classList.add('mbi-recall-signature-helper');
    var field = signature.parentElement;
    if (field && field.parentElement && !helper.isConnected) {
      field.parentElement.insertBefore(helper, field.nextSibling);
    }
    addDescription(signature, helperId);
  }

  function writeSubmissionMetadata(root, host) {
    var now = new Date();
    var submission = {
      reference: 'MBI' + now.toISOString().replace(/\D/g, ''),
      country: countryName(selectedCountryCode()) || selectedCountryCode()
    };
    var referenceInput = findInput(root, /^(?:claim\s*reference|numer\s*zgłoszenia|numer\s*referencyjny\s*roszczenia)$/i);
    var countryInput = findInput(root, /^(?:country\s*of\s*purchase|kraj\s*zakupu)$/i);

    if (referenceInput) {
      setFormValue(referenceInput, submission.reference);
      lockSystemField(referenceInput, true);
    }
    if (countryInput) {
      setFormValue(countryInput, submission.country);
      lockSystemField(countryInput, false);
    }
    submissionByHost.set(host, submission);
    return submission;
  }

  function initialiseMetadataFields(root, host) {
    var existing = submissionByHost.get(host);
    var referenceInput = findInput(root, /^(?:claim\s*reference|numer\s*zgłoszenia|numer\s*referencyjny\s*roszczenia)$/i);
    var timestampInput = findInput(root, /^submission\s*timestamp(?:\s*\(utc\))?$/i);
    var countryInput = findInput(root, /^(?:country\s*of\s*purchase|kraj\s*zakupu)$/i);
    if (referenceInput) {
      if (existing && referenceInput.value !== existing.reference) {
        setFormValue(referenceInput, existing.reference);
      }
      if (!existing && !referenceInput.value) {
        referenceInput.setAttribute('placeholder', text('referencePlaceholder'));
      }
      lockSystemField(referenceInput, true);
    }
    if (timestampInput) lockSystemField(timestampInput, true);
    if (countryInput) {
      var selectedCountry = countryName(selectedCountryCode()) || selectedCountryCode();
      if (countryInput.value !== selectedCountry) setFormValue(countryInput, selectedCountry);
      lockSystemField(countryInput, false);
    }
  }

  function bindFormSubmit(root, host) {
    var form = root.querySelector('form');
    if (!form || form.getAttribute('data-mbi-recall-submit') === 'true') return;
    form.setAttribute('data-mbi-recall-submit', 'true');
    form.addEventListener('submit', function () {
      writeSubmissionMetadata(root, host);
    }, true);
  }

  function enhanceSuccess(root, host) {
    var banner = root.querySelector('[data-testid="banner-success"]');
    if (!banner) return;

    if (!banner.hasAttribute('data-mbi-recall-scrolled')) {
      banner.setAttribute('data-mbi-recall-scrolled', '');
      window.setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);
    }

    var pageGuidance = document.querySelector('.mbi-product-recall--form');
    if (pageGuidance) pageGuidance.hidden = true;

    if (banner.querySelector('[data-mbi-recall-reference]')) return;
    var submission = submissionByHost.get(host);
    if (!submission) return;

    var panel = document.createElement('div');
    panel.className = 'mbi-recall-reference';
    panel.setAttribute('data-mbi-recall-reference', '');

    var referenceLabel = document.createElement('p');
    referenceLabel.textContent = text('referenceLabel');
    var reference = document.createElement('strong');
    reference.className = 'mbi-recall-reference__code';
    reference.textContent = submission.reference;
    var copyButton = document.createElement('button');
    copyButton.type = 'button';
    copyButton.className = 'mbi-recall-reference__copy';
    copyButton.textContent = text('copyReference');
    copyButton.setAttribute('aria-describedby', 'mbi-recall-reference-status');
    var status = document.createElement('p');
    status.id = 'mbi-recall-reference-status';
    status.className = 'mbi-recall-reference__status';
    status.setAttribute('aria-live', 'polite');
    status.textContent = text('keepReference');
    var anotherCopy = document.createElement('p');
    anotherCopy.className = 'mbi-recall-reference__another-copy';
    anotherCopy.textContent = text('anotherCopy');
    var anotherLink = document.createElement('a');
    anotherLink.className = 'mbi-recall-reference__another';
    anotherLink.textContent = text('anotherLink');
    anotherLink.href = recallRoute('form') + '?country=' +
      encodeURIComponent(selectedCountryCode()) + '&another=1';

    copyButton.addEventListener('click', function () {
      var copy = text('clipboardCopy') + ' ' + submission.reference;
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        status.textContent = text('selectManually');
        return;
      }
      navigator.clipboard.writeText(copy).then(function () {
        status.textContent = text('referenceCopied');
      }, function () {
        status.textContent = text('selectManually');
      });
    });

    panel.appendChild(referenceLabel);
    panel.appendChild(reference);
    panel.appendChild(copyButton);
    panel.appendChild(status);
    panel.appendChild(anotherCopy);
    panel.appendChild(anotherLink);
    banner.appendChild(panel);
  }

  function enhanceHost(host) {
    var root = host.shadowRoot;
    if (!root) return;
    addShadowStyles(root);
    markFormHeadings(root);
    enhancePhoneControl(root);
    enhanceRecallPhoto(root);
    enhanceBatchCode(root);
    enhanceSignature(root);
    initialiseMetadataFields(root, host);
    markFormLayout(root);
    restrictIsbnOptions(root);
    bindFormSubmit(root, host);
    enhanceSuccess(root, host);

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      new MutationObserver(function () { enhanceHost(host); })
        .observe(root, { childList: true, subtree: true });
    }
  }

  function scanForms() {
    document.querySelectorAll(FORM_SELECTOR).forEach(enhanceHost);
  }

  function scanPage() {
    enhanceLanguageSwitcher();
    populateCountrySelector();
    enhanceCountryForm();
    enhanceRecallRoutes();
    enhanceImages();
    enhancePageEligibility();
    applyCountryScopes();
    scanForms();
  }

  new MutationObserver(scanForms).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  window.addEventListener('pageshow', scanPage);
  scanPage();

  var attempts = 0;
  var hydrationTimer = window.setInterval(function () {
    scanForms();
    attempts += 1;
    if (attempts >= 40) window.clearInterval(hydrationTimer);
  }, 250);
})();
